import { FunctionComponent, memo } from "react";
import { IProps } from "./role-summary.types";
import RoleActionsMenu from "../role-actions-menu";
import "./role-summary.scss";

/**
 * Summary details for a role, including a button for edit and remove
 * @param props.role     Information about the role
 */
const RoleSummary: FunctionComponent<IProps> = ({ role }) => {
    return (
        <div className="role-summary">
            <div className="role-summary__title">{role.role}</div>
            <RoleActionsMenu role={role} />
        </div>
    );
};

export default memo(RoleSummary);
